export enum GuidedChangeType {
  ApplyFullConfiguration = "APPLY_FULL_CONFIGURATION",
  ApplyPartialConfiguration = "APPLY_PARTIAL_CONFIGURATION",
  AddOnBookOption = "ADD_ON_BOOK_OPTION",
  ConfigurationTrueUp = "CONFIGURATION_TRUE_UP",
  SwapProductInCatalog = "SWAP_PRODUCT_IN_CATALOG",
  SwapProductNotInCatalog = "SWAP_PRODUCT_NOT_IN_CATALOG",
  FullLineCustomOption = "FULL_LINE_CUSTOM_OPTION",
}

type GuidedChangeEventTypeOption = { value: GuidedChangeType; label: string; description: string };

export const guidedChangeTypeOptions: GuidedChangeEventTypeOption[] = [
  {
    value: GuidedChangeType.ApplyFullConfiguration,
    label: "Apply Full Configuration",
    description: "Replace the entire configuration on this structure.",
  },
  {
    value: GuidedChangeType.ApplyPartialConfiguration,
    label: "Apply Partial Configuration",
    description: "Apply selected changes from another configuration.",
  },
  {
    value: GuidedChangeType.AddOnBookOption,
    label: "Add an On-Book Option",
    description: "Add an existing product offering option that's not yet in this project.",
  },
  {
    value: GuidedChangeType.ConfigurationTrueUp,
    label: "Configuration True-Up",
    description: "Re-base to the latest product offering version to pull in new bids, costs and takeoffs.",
  },
  {
    value: GuidedChangeType.SwapProductInCatalog,
    label: "Swap a Product (In Catalog)",
    description: "Replace one catalog product with another we already have a bid for.",
  },
  {
    value: GuidedChangeType.SwapProductNotInCatalog,
    label: "Swap a Product (Not in Catalog)",
    description: "Replace with a product we don't have a cost for. Cost entered manually.",
  },
  {
    value: GuidedChangeType.FullLineCustomOption,
    label: "Full-Line Custom Option",
    description: "Add new scope not offered anywhere (ex Juliet Balcony). Estimator assisted.",
  },
];

export enum GuidedChangeEventStep {
  DefineChange = "define-change",
  SelectConfiguration = "select-configuration",
  ReviewConfiguration = "review-configuration",
  ReviewImpact = "review-impact",
  Review = "review",
}

export enum GuidedChangeEventConfigType {
  CheckoutConfig = "checkoutConfig",
  ProductOfferingConfig = "productOfferingConfig",
}
